import { createContext } from "react";

export const CustomEventNamesContext = createContext<string[]>([]);
